// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vTxL","top":"styles_top__28zMm","left":"styles_left__2DuNV","description":"styles_description__2Qjvn"};